import { createContext, useContext } from 'react';
import { ActorRefFrom } from 'xstate';
import { vaultState } from './vaultState.machine';

type AccountActorRef = ActorRefFrom<typeof vaultState>;
export const AccountRefContext = createContext<AccountActorRef | null>(null);

export function useAccountActorRef() {
  const ref = useContext(AccountRefContext);
  if (!ref) throw new Error('useAccountActorRef must be used within UserState.Provider');
  return ref;
}
